export enum JobStatus {
  DRAFT = "DRAFT",
  RELEASED = "RELEASED",
  PLANNED = "PLANNED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  SUSPENDED = "SUSPENDED",
  CLOSED = "CLOSED"
}
